import React from 'react'
import { css, StyleSheet } from 'aphrodite/no-important'

import { Icon } from '../../../../components/generic'
import { colors } from '@lmc/common/constants'

const renderPayeeOptionTitle = (props) => {
  const { payee, onClick, isActive } = props

  const payeeOptionTitleContainerStyles = onClick
    ? styles.payeeOptionTitleContainer
    : { ...styles.payeeOptionTitleContainer, justifyContent: 'center' }

  return (
    <div style={payeeOptionTitleContainerStyles}>
      {/* Can't quite believe we need this blank div... */}
      {onClick && <div style={{ width: 24 }} />}
      <div style={styles.payeeOptionTitle}>{payee}</div>
      {onClick && (
        <Icon
          name={isActive ? 'radio-on' : 'radio-off'}
          fill={isActive ? colors.pink : null}
          size={24}
        />
      )}
    </div>
  )
}

// Monthly cost section

const renderCostSubtitle = (activeResidents, preferredPeopleNominative) => {
  if (!activeResidents) {
    return 'Families will pay this'
  } else if (activeResidents < 4) {
    return 'Care Service will pay this.'
  } else {
    return (
      <div>
        Care Service will pay this. £5 x <b>{activeResidents}</b> active{' '}
        {preferredPeopleNominative} (+ VAT)
      </div>
    )
  }
}

const renderMonthlyCostSection = (props) => {
  const { costPerMonth, activeResidents, preferredPeopleNominative } = props

  return (
    <div style={styles.monthlyCostContainer}>
      <div style={styles.monthlyCostTitle}>
        {`£${costPerMonth} ${activeResidents ? '(+ VAT)' : ''} per month`}
      </div>
      <div style={styles.monthlyCostSubtitle}>
        {renderCostSubtitle(activeResidents, preferredPeopleNominative)}
      </div>
    </div>
  )
}

//  Cost text section

const renderCostBulletPoints = (props) => {
  const { bulletPoint1, bulletPoint2, bulletPoint3 } = props
  return (
    <div style={styles.costMainText}>
      <ul style={styles.costBulletPoints}>
        <li style={{ paddingLeft: 5 }}>{bulletPoint1}</li>
        <li style={{ paddingLeft: 5 }}>{bulletPoint2}</li>
        <li style={{ paddingLeft: 5 }}>{bulletPoint3}</li>
      </ul>
    </div>
  )
}

const renderCostTextSection = (props) => {
  const { bulletPoint1, bulletPoint2, bulletPoint3, mainText } = props

  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ ...styles.costMainText, marginBottom: 8 }}>{mainText}</div>
      {renderCostBulletPoints({ bulletPoint1, bulletPoint2, bulletPoint3 })}
    </div>
  )
}

export default function FamilyPaymentOption(props) {
  const {
    imgUrl,
    title,
    payee,
    costPerMonth,
    mainText,
    bulletPoint1,
    bulletPoint2,
    bulletPoint3,
    activeResidents,
    onClick,
    isActive,
    preferredPeopleNominative,
  } = props

  const classes = StyleSheet.create({
    paymentOptionBox: {
      ...styles.inviteBox,
      padding: '0 16px',
      flexGrow: 1,
      cursor: onClick && 'pointer',
      border: `1px solid ${isActive ? colors.pink : colors.grey}`,
      ':hover': onClick ? { border: `1px solid ${colors.pink}` } : {},
    },
  })

  return (
    <div style={styles.costOptionSectionContainer}>
      <div className={css(classes.paymentOptionBox)} onClick={onClick}>
        {renderPayeeOptionTitle({ payee, onClick, isActive })}
        <div style={styles.greyLine} />
        {renderMonthlyCostSection({
          costPerMonth,
          activeResidents,
          preferredPeopleNominative,
        })}
        <div style={styles.greyLine} />
        <div style={styles.costImageContainer}>
          <img alt="" src={imgUrl} style={styles.costImage} />
        </div>
        {renderCostTextSection({
          bulletPoint1,
          bulletPoint2,
          bulletPoint3,
          mainText,
        })}
      </div>
    </div>
  )
}

const styles = {
  costBulletPoints: {
    paddingLeft: 20,
    margin: 0,
  },
  costImage: {
    height: 140,
  },
  costImageContainer: {
    margin: '28px 0 32px 0',
  },
  costLearnMoreBtn: {
    padding: '50px 0 16px 0',
    display: 'flex',
    justifyContent: 'center',
  },
  costOptionSectionContainer: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
  },
  costOptionTitle: {
    fontSize: 18,
    lineHeight: '32px',
    color: colors.pink,
    textAlign: 'center',
    paddingBottom: 8,
  },
  costMainText: {
    fontSize: 14,
    lineHeight: '22px',
  },
  costSetupBtn: {
    display: 'flex',
    justifyContent: 'center',
  },
  greyLine: {
    height: 1,
    background: colors.grey,
    width: '100%',
  },
  inviteBox: {
    alignItems: 'center',
    background: colors.white,
    borderRadius: 4,
    border: `1px solid ${colors.grey}`,
    display: 'flex',
    flexDirection: 'column',
  },
  monthlyCostContainer: {
    padding: '24px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  monthlyCostSubtitle: {
    color: colors.darkgrey,
    marginTop: 8,
    lineHeight: '18px',
    fontSize: 12,
  },
  monthlyCostTitle: {
    fontSize: 18,
    lineHeight: '32px',
    fontWeight: 'bold',
  },
  payeeOptionTitle: {
    fontSize: 18,
    lineHeight: '32px',
  },
  payeeOptionTitleContainer: {
    padding: '16px 0 16px 0',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}
